import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Loader } from "../../../../common/Loader/Loader";
import {
  GetInTransitBookingManagementSlice,
  GetOrderslistBookingManagementSlice,
  UpdateStatusManagementCompleteSlice,
} from "../../../../redux/features/BookingManagementSlice";
import Pagination from "../../../../common/pagination/PaginationCustom";
import useParamsFormat from "../../../../common/Params Values format/ParamsFormat";
import { toast } from "react-toastify";
import { WhatsappIcon, WhatsappShareButton } from "react-share";
import { FaCopy } from "react-icons/fa";

const InTransitOrders = () => {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const { createDataSetParams } = useParamsFormat();
  const [pagination, setPagination] = useState([]);
  const [handleArrforPage, setHandleArrforPage] = useState(1);
  const [arr, setArr] = useState([]);
  const [page, setPage] = useState(1);
  const [getSearch, setGetSearch] = useState({
    search: "",
    fromDate: "",
    toDate: "",
    page: 1,
  });

  const { loading } = useSelector((state) => state.BookingManagement);

  useEffect(() => {
    const dataSet = createDataSetParams(getSearch);

    dispatch(GetInTransitBookingManagementSlice(dataSet)).then((res) => {
      setData(res?.payload?.data);
      setPagination(res.payload.pagination);
    });
  }, []);

  useEffect(() => {
    if (Object.entries(pagination ?? {}).length > 0) {
      setArr(
        [...Array(pagination?.totalPages + 1).keys()]
          .slice(1)
          .slice(handleArrforPage - 1, handleArrforPage + 2)
      );
    }
  }, [pagination, handleArrforPage]);

  const handlePagesIncrease = () => {
    console.log("handleIncrease:", handleArrforPage);
    if (handleArrforPage + 3 <= pagination?.totalPages) {
      setHandleArrforPage((prev) => prev + 3);
    }
  };

  const handlePagesDecrease = () => {
    if (handleArrforPage > 2) {
      setHandleArrforPage((prev) => prev - 3);
    }
  };

  const FetchDataOnPages = (pageNum) => {
    setPage(pageNum);

    setGetSearch((prev) => ({ ...prev, page: pageNum }));

    const dataSet = createDataSetParams({ ...getSearch, page: pageNum });

    dispatch(GetInTransitBookingManagementSlice(dataSet)).then((res) => {
      const dummyData = res?.payload?.data;
      setData(dummyData);
      setPagination(res.payload.pagination);
    });
  };

  const handleStatusUpdate = (id) => {
    const data = {
      id: id,
      data: {
        status: "completed",
      },
    };
    dispatch(UpdateStatusManagementCompleteSlice(data)).then((res) => {
      dispatch(GetInTransitBookingManagementSlice()).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    });
  };

  const HandleSearch = () => {
    //search=hello&fromDate=2024-12-05&toDate=2024-12-19&
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      if (
        ![getSearch.fromDate.length, getSearch.toDate.length].every(
          (item) => item === 0
        )
      ) {
        if (
          ![getSearch.fromDate.length, getSearch.toDate.length].every(
            (item) => item > 0
          )
        ) {
          toast.error("Please complete the date!");
          return;
        }
      }

      dispatch(
        GetInTransitBookingManagementSlice(createDataSetParams(getSearch))
      ).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    }
  };

  const HandleReset = () => {
    if (
      Object.entries(getSearch)
        .map(([key, value]) => value.length)
        .some((item) => item > 0)
    ) {
      setGetSearch({
        search: "",
        fromDate: "",
        toDate: "",
        page: 1,
      });

      dispatch(GetInTransitBookingManagementSlice()).then((res) => {
        const dummyData = res?.payload?.data;
        setData(dummyData);
        setPagination(res.payload.pagination);
      });
    }
  };

const handleCopy = (item, CopyTo) => {
    const formatDate = (dateString) => {
      if (!dateString) return 'N/A';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { 
        day: 'numeric', 
        month: 'long' 
      });
    };

    const textToCopy = `Order Details:

Order ID: #${item.orderId}

Order Date: ${formatDate(item.createdAt || item.orderDate)}

Address: ${item?.deliveryAddress?.houseNo ? `${item.deliveryAddress.houseNo}, ` : ''}${item?.deliveryAddress?.street ? `${item.deliveryAddress.street}, ` : ''}${item?.deliveryAddress?.city ? `${item.deliveryAddress.city}, ` : ''}${item?.deliveryAddress?.state ? `${item.deliveryAddress.state}. ` : ''}${item?.deliveryAddress?.pincode ? `Pin ${item.deliveryAddress.pincode}` : ''}

${item?.deliveryAddress?.pincode || ''}
GoogleMapLocation: https://www.google.com/maps/search/?q=%20https%3A%2F%2Fmaps.app.goo.gl%2FuGU5FJRMF4dPPXqP9%3Fg_st%3Dac%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%0A%0A

Arrival Time: ${item?.arrivalTime || item?.deliveryTime || '4:00 PM'}

Amount: ₹${item?.totalAmount || '0'}/-

Comments:
${item?.comments || item?.specialInstructions || 'No special comments'}

Add-On Items:
${item?.addOns ? item.addOns.map((addon, index) => `${index + 1}. ${addon.name} Quantity ${addon.quantity}: ₹${addon.price || '0'}`).join('\n') : 'No add-on items'}

Product Name: ${item?.productName || 'N/A'}
Image URL: ${item?.prodimages?.[0] || item?.productImage || 'No image available'}

Inclusion: 
${item?.inclusion || item?.productInclusion || 'No inclusion details available'}

Customer: ${item?.customerFullName}
Phone: ${item?.customerContactNumber}`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        if (CopyTo !== "WhatsApp") toast.success("data copied to clipboard!");
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  return (
    <>
      <div>
        <div className="Small-Wrapper">
          <div className="Filter justify-content-between">
            <div className="Filter">
              <div className="form-group">
                <label>Search</label>
                <input
                  type="search"
                  className="form-control"
                  placeholder="Search"
                  name="search"
                  value={getSearch?.search}
                  onChange={(e) =>
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="form-group">
                <label>From Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="fromDate"
                  value={getSearch?.fromDate}
                  onChange={(e) =>
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input
                  type="date"
                  className="form-control"
                  value={getSearch?.toDate}
                  name="toDate"
                  onChange={(e) =>
                    setGetSearch((prev) => ({
                      ...prev,
                      [e.target.name]: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="form-group">
                <label>&nbsp;</label>
                <button
                  className="Button"
                  style={{ marginRight: "10px" }}
                  onClick={HandleSearch}
                >
                  Apply
                </button>

                <button className="Button Cancel" onClick={HandleReset}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="TableList">
          <table style={{ width: "180%" }}>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Booking Id</th>
                <th>Booking Date &amp; Time</th>
                <th>Customer id</th>
                <th>Customer name</th>
                <th>Customer contact details</th>
                <th>Delivery address</th>
                <th>Amount (in TZS)</th>
                <th>Payment Mode</th>
                {/* <th>Update Booking status</th> */}
                <th>View Booking details</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={13}>
                    <Loader />
                  </td>
                </tr>
              ) : Array.isArray(data) && data?.length > 0 ? (
                data?.map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{(pagination?.currentPage - 1) * 10 + index + 1}</td>
                      <td>{item?.orderId}</td>
                      <td>{item?.createdAt?.slice(0, 10)}</td>
                      <td>{item?.userId}</td>
                      <td>{item?.customerFullName}</td>
                      <td>{item?.customerContactNumber}</td>
                      <td style={{ width: 400 }}>
                        {item?.deliveryAddress?.street},
                        {item?.deliveryAddress?.pincode}
                      </td>
                      <td>{item?.totalAmount}</td>
                      <td>{item?.paymentMode}</td>

                      <td>
                        <div className="Actions">
                          <Link
                            className="Blue"
                            to={`/OrderManagment/OrderActiveConfirmDetails/${item?._id}`}
                          >
                            <i className="fa fa-eye" />
                          </Link>
                          <Link
                            to={`/OrderManagment/ConfirmedBooking/CancelOrder/${item?._id}`}
                            href="javascript:void(0);"
                            className="RedCancel"
                            data-toggle="modal"
                            data-target="#CancelOrder"
                          >
                            Cancel
                          </Link>
                        </div>
                      </td>
                      <td>
                        <button
                          className="btn btn-success"
                          onClick={() => handleStatusUpdate(item?._id)}
                        >
                          Complete
                        </button>
                        <div onClick={() => handleCopy(item, "WhatsApp")}>
                          <WhatsappShareButton
                            url={`Order Details:

Order ID: #${item.orderId}

Order Date: ${new Date(item.createdAt || item.orderDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'long' }) || 'N/A'}

Address: ${item?.deliveryAddress?.houseNo ? `${item.deliveryAddress.houseNo}, ` : ''}${item?.deliveryAddress?.street ? `${item.deliveryAddress.street}, ` : ''}${item?.deliveryAddress?.city ? `${item.deliveryAddress.city}, ` : ''}${item?.deliveryAddress?.state ? `${item.deliveryAddress.state}. ` : ''}${item?.deliveryAddress?.pincode ? `Pin ${item.deliveryAddress.pincode}` : ''}

${item?.deliveryAddress?.pincode || ''}
GoogleMapLocation: https://www.google.com/maps/search/?q=%20https%3A%2F%2Fmaps.app.goo.gl%2FuGU5FJRMF4dPPXqP9%3Fg_st%3Dac%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%0A%0A

Arrival Time: ${item?.arrivalTime || item?.deliveryTime || '4:00 PM'}

Amount: ₹${item?.totalAmount || '0'}/-

Product Name: ${item?.productName || 'N/A'}

Customer: ${item?.customerFullName}
Phone: ${item?.customerContactNumber}

Product Image: ${item?.prodimages?.[0] || item?.productImage || 'No image available'}`}
                            media={item?.prodimages?.[0] || item?.productImage}
                          >
                            <WhatsappIcon size={40} round={true} />
                          </WhatsappShareButton>
                        </div>
                        <div
                          style={{ cursor: "pointer" }}
                          onClick={() => handleCopy(item)}
                        >
                          <FaCopy style={{ fontSize: "27px" }} />
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={13}>There is no data found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          arr={arr}
          page={page}
          handlePagesIncrease={handlePagesIncrease}
          FetchDataOnPages={FetchDataOnPages}
          handlePagesDecrease={handlePagesDecrease}
        />
      </div>
    </>
  );
};

export default InTransitOrders;
